import { Record } from "immutable";
import { DOCUMENT_CURRENT_STATUS } from "constants/enums";
export class CaseDocumentRecord extends Record({
    id: null,
    case: null,
    company: null,
    associate: null,
    company_bank: null,
    doc_name: null,
    document: null,
    document_end_date: null,
    document_start_date: null,
    document_type: null,
    file: null,
    file_name: null,
    is_active: null,
    create_date: null,
    created_by: null,
    modified_by: null,
    modified_date: null,
    is_valid: null,
    remarks: null,
    file_mime_type: null,
    request_remarks: null,
    is_guarantor : null
}) {}

export class CompanyDocumentRecord extends Record({
    company: null,
    create_date: null,
    created_by: null,
    file: null,
    file_name: null,
    id: null,
    is_active: null,
    modified_by: null,
    modified_date: null,
    is_valid: null,
    remarks: null,
    is_parsed: null,
    file_mime_type: null,
    parse_data: null,
    document: null,
    document_status: null,
    parent_document_master: null,
    request_remarks: null,
    document_option : null,
    associate : null,
}) {

    get validatedValues() {
        return {
            file_name: this.file_name,
            id: this.id,
            document_option : this.document_option ? this.document_option : null,
            document: this.document? this.document.id :null,
            document_status: this.document_status,
            is_active: this.is_active,
            remarks: this.remarks,
            parse_data: this.parse_data,
            request_remarks: this.request_remarks
        };
    }

    get name() {
        if(this.document_status === DOCUMENT_CURRENT_STATUS.get("Requested")) {
            return this.document && this.document.document_name;
        }
        return this.file_name;
    }

}
